// src/utils/PageViewTracker.js
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

export default function PageViewTracker() {
  const location = useLocation();

  // Extract all four IDs from Redux (menu data). Each may be null/undefined.
  const menuInfo = useSelector((state) => state.menuInfo);

  const { menuData } = menuInfo;

  const { gtm_id, fb_pixel_id, ga_tracking_id, google_ads_id } = menuData;

  useEffect(() => {
    // Build a "canonical" page string (same as gtag expects):
    const page_path = location.pathname + location.search;

    // ---- 1) Google Tag Manager ----
    // If GTM was initialized, window.dataLayer should exist.
    if (gtm_id && window.dataLayer) {
      window.dataLayer.push({
        event: "pageview",
        page: page_path,
      });
    }

    // ---- 2) Facebook Pixel ----
    // If fb_pixel_id was initialized, window.fbq exists.
    if (fb_pixel_id && window.fbq) {
      window.fbq("track", "PageView");
    }

    // ---- 3) Google Analytics (gtag.js) ----
    // If ga_tracking_id was provided and gtag.js is loaded, call config to record a pageview.
    if (ga_tracking_id && window.gtag) {
      window.gtag("config", ga_tracking_id, {
        page_path,
      });
    }

    // ---- 4) Google Ads (gtag.js) ----
    // If google_ads_id was provided and gtag.js is loaded, call config to record a pageview for Ads.
    if (google_ads_id && window.gtag) {
      window.gtag("config", google_ads_id, {
        page_path,
      });
    }
  }, [location, gtm_id, fb_pixel_id, ga_tracking_id, google_ads_id]);

  return null;
}
